// The traced remnant outline with every side measured, same drawing as the tag.
const SW = 320;
const SH = 170;
const PAD = 26;

export const RemnantShapeDims = ({
  polygon,
  length,
  width,
  testId = "remnant-shape-dims",
  className = "",
}) => {
  const poly = (polygon || [])
    .map((p) => ({ x: Number(p.x ?? p[0] ?? 0), y: Number(p.y ?? p[1] ?? 0) }))
    .filter((p) => Number.isFinite(p.x) && Number.isFinite(p.y));
  if (poly.length < 3) return null;

  const L = Number(length) || 1;
  const W = Number(width) || 1;
  const round1 = (n) => Math.round(n * 10) / 10;
  const xs = poly.map((p) => p.x);
  const ys = poly.map((p) => p.y);
  const minX = Math.min(...xs);
  const minY = Math.min(...ys);
  const spanX = Math.max(...xs) - minX || 1;
  const spanY = Math.max(...ys) - minY || 1;
  const boxW = SW - PAD * 2;
  const boxH = SH - PAD * 2;
  const at = (p) => ({
    x: PAD + ((p.x - minX) / spanX) * boxW,
    y: PAD + ((p.y - minY) / spanY) * boxH,
  });

  const points = poly.map((p) => `${at(p).x},${at(p).y}`).join(" ");
  const sides = poly.map((p, i) => {
    const q = poly[(i + 1) % poly.length];
    const dx = (q.x - p.x) * L;
    const dy = (q.y - p.y) * W;
    const a = at(p);
    const b = at(q);
    return {
      len: round1(Math.sqrt(dx * dx + dy * dy)),
      mx: (a.x + b.x) / 2,
      my: (a.y + b.y) / 2,
    };
  });

  return (
    <div className={className} data-testid={testId}>
      <div className="font-mono-data text-[10px] uppercase tracking-[0.22em] text-zinc-500">
        Shape — all sides in inches
      </div>
      <div className="relative mt-2">
        <svg viewBox={`0 0 ${SW} ${SH}`} className="w-full">
          <polygon
            points={points}
            fill="rgba(99,102,241,0.16)"
            stroke="#818cf8"
            strokeWidth="2.5"
            strokeLinejoin="round"
          />
        </svg>
        {sides.map((sd, i) => (
          <span
            key={i}
            data-testid={`${testId}-side-${i}`}
            style={{
              left: `${(sd.mx / SW) * 100}%`,
              top: `${(sd.my / SH) * 100}%`,
            }}
            className="font-mono-data absolute -translate-x-1/2 -translate-y-1/2 rounded bg-[#c39e6d] px-1.5 py-0.5 text-[10px] font-bold text-zinc-950"
          >
            {sd.len}&quot;
          </span>
        ))}
      </div>
    </div>
  );
};
